import React from 'react';
import { useAuth } from '../context/AuthContext';
import AdminDashboardHome from './AdminDashboardHome';

function AdminDashboard() {
  const { user } = useAuth();

  return (
    <div data-testid="admin-dashboard">
      {/* Dashboard Header */}
      <h2 className="h2 mb-8">Dashboard Overview</h2>

      {/* Analytics Dashboard - Contains all stats and charts */}
      <AdminDashboardHome />
        
      {/* Quick Navigation */}
      <div className="mt-8">
        <h3 className="font-semibold text-lg mb-4">Management</h3>
        <div className="grid md:grid-cols-4 gap-4">
          <button
            onClick={() => window.location.href = '/admin/ai-insights'}
            className="bg-gradient-to-br from-purple-50 to-primary/10 border-2 border-purple-300 rounded-[var(--radius)] p-4 text-left hover:border-purple-500 transition-smooth"
            data-testid="ai-insights-btn"
          >
            <h4 className="font-semibold mb-1 text-purple-700">✨ AI Insights</h4>
            <p className="text-sm text-muted-foreground">Smart participant flagging</p>
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/facilitator'}
            className="bg-primary/5 border-2 border-primary/30 rounded-[var(--radius)] p-4 text-left hover:border-primary/70 transition-smooth"
            data-testid="facilitator-mode-btn"
          >
            <h4 className="font-semibold mb-1 text-primary">Facilitator Mode</h4>
            <p className="text-sm text-muted-foreground">Conduct live sessions</p>
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/participants'}
            className="bg-card border border-border rounded-[var(--radius)] p-4 text-left hover:border-primary/50 transition-smooth"
            data-testid="view-participants-btn"
          >
            <h4 className="font-semibold mb-1">Participants</h4>
            <p className="text-sm text-muted-foreground">View and manage all participants</p>
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/prompts'}
            className="bg-card border border-border rounded-[var(--radius)] p-4 text-left hover:border-primary/50 transition-smooth"
          >
            <h4 className="font-semibold mb-1">Prompts</h4>
            <p className="text-sm text-muted-foreground">Manage assessment prompts</p>
          </button>
        </div>
        <div className="grid md:grid-cols-4 gap-4 mt-4">
          <button
            onClick={() => window.location.href = '/admin/cohorts'}
            className="bg-gradient-to-br from-emerald-50 to-teal-100 border-2 border-emerald-300 rounded-[var(--radius)] p-4 text-left hover:border-emerald-500 transition-smooth"
            data-testid="cohort-management-btn"
          >
            <h4 className="font-semibold mb-1 text-emerald-700">Cohort Management</h4>
            <p className="text-sm text-muted-foreground">Group and track participants</p>
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/testimonials'}
            className="bg-gradient-to-br from-amber-50 to-orange-100 border-2 border-amber-300 rounded-[var(--radius)] p-4 text-left hover:border-amber-500 transition-smooth"
            data-testid="testimonials-btn"
          >
            <h4 className="font-semibold mb-1 text-amber-700">Testimonials</h4>
            <p className="text-sm text-muted-foreground">Collect and manage testimonials</p>
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/bookings'}
            className="bg-card border border-border rounded-[var(--radius)] p-4 text-left hover:border-primary/50 transition-smooth"
          >
            <h4 className="font-semibold mb-1">Bookings</h4>
            <p className="text-sm text-muted-foreground">View scheduled sessions</p>
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/applications'}
            className="bg-card border border-border rounded-[var(--radius)] p-4 text-left hover:border-primary/50 transition-smooth"
          >
            <h4 className="font-semibold mb-1">Applications</h4>
            <p className="text-sm text-muted-foreground">Review pilot applications</p>
          </button>
        </div>
      </div>
      
      {/* Email & Settings */}
      <div className="mt-8">
        <h3 className="font-semibold text-lg mb-4">Email & Settings</h3>
        <div className="grid md:grid-cols-4 gap-4">
          <button
            onClick={() => window.location.href = '/admin/email-templates'}
            className="bg-card border border-border rounded-[var(--radius)] p-4 text-left hover:border-primary/50 transition-smooth"
            data-testid="manage-email-templates-btn"
          >
            <h4 className="font-semibold mb-1">Email Templates</h4>
            <p className="text-sm text-muted-foreground">Create email templates</p>
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/email-sequences'}
            className="bg-card border border-border rounded-[var(--radius)] p-4 text-left hover:border-primary/50 transition-smooth"
            data-testid="manage-email-sequences-btn"
          >
            <h4 className="font-semibold mb-1">Email Sequences</h4>
            <p className="text-sm text-muted-foreground">Configure automations</p>
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/email-logs'}
            className="bg-card border border-border rounded-[var(--radius)] p-4 text-left hover:border-primary/50 transition-smooth"
            data-testid="view-email-logs-btn"
          >
            <h4 className="font-semibold mb-1">Email Logs</h4>
            <p className="text-sm text-muted-foreground">Track sent emails</p>
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/activity-logs'}
            className="bg-gradient-to-br from-slate-50 to-slate-100 border-2 border-slate-300 rounded-[var(--radius)] p-4 text-left hover:border-slate-500 transition-smooth"
            data-testid="activity-logs-btn"
          >
            <h4 className="font-semibold mb-1 text-slate-700">Activity Logs</h4>
            <p className="text-sm text-muted-foreground">Monitor all events</p>
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/webhooks'}
            className="bg-gradient-to-br from-indigo-50 to-violet-100 border-2 border-indigo-300 rounded-[var(--radius)] p-4 text-left hover:border-indigo-500 transition-smooth"
            data-testid="webhooks-btn"
          >
            <h4 className="font-semibold mb-1 text-indigo-700">Webhooks</h4>
            <p className="text-sm text-muted-foreground">Event notifications</p>
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/content'}
            className="bg-gradient-to-br from-cyan-50 to-sky-100 border-2 border-cyan-300 rounded-[var(--radius)] p-4 text-left hover:border-cyan-500 transition-smooth"
            data-testid="content-library-btn"
          >
            <h4 className="font-semibold mb-1 text-cyan-700">Content Library</h4>
            <p className="text-sm text-muted-foreground">Articles, videos & guides</p>
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/settings'}
            className="bg-card border border-border rounded-[var(--radius)] p-4 text-left hover:border-primary/50 transition-smooth"
            data-testid="admin-settings-btn"
          >
            <h4 className="font-semibold mb-1">Settings</h4>
            <p className="text-sm text-muted-foreground">API keys & configuration</p>
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
